import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const STORED_ITEMS_DETAILS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/stored-item',
        iconClass: 'fas fa-search',
        name: '::Menu:StoredItemDetails',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.StoredItems',
        order: 2,
        invisible:true
      },
    ]);
  };
}
